type BoolString = "true" | "false";

export const getBooleanEnumValue = (value?: BoolString): boolean => {
  return value === "true";
};

export const getBooleanEnumString = (value?: boolean): BoolString => {
  return value ? "true" : "false";
};
